import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpParams, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { handleError } from "../../shared/handle-error";
import { TemporaryPassword } from "./temporary-password.model";
import { User } from "./user.model";
import { UserListing } from "./user-listing.model";
import { UserOptions } from "./user-options.model";

@Injectable()
export class UserService {
    private usersUrl = "api/users";  // url to web api

    constructor(private http: HttpClient) { }

    getUser(id: number): Promise<User> {
        const url = `${this.usersUrl}/${id}`;
        return this.http.get<User>(url)
            .toPromise()
            .catch(handleError);
    }

    getListing(): Promise<UserListing[]> {
        return this.http.get<UserListing[]>(this.usersUrl)
            .toPromise()
            .catch(handleError);;
    }

    getOptions(): Promise<UserOptions> {
        const url = `${this.usersUrl}/options`;
        return this.http.get<User>(url)
            .toPromise()
            .catch(handleError);
    }

    resetPassword(userID: number): Promise<TemporaryPassword> {
        const url = `${this.usersUrl}/${userID}/reset-password`;
        return this.http.post(url, null)
            .toPromise()
            .catch(handleError);
    }

    update(user: User): Promise<User> {
        const url = `${this.usersUrl}/${user.id}`;
        return this.http.put(url, user)
            .toPromise()
            .then(() => user)
            .catch(handleError);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/admin/shared/user.service.ts